import { createFileRoute } from '@tanstack/react-router';

import { getAwardQueryOptions } from '@/_pages/awards/api-service';
import Loading from '@/_pages/awards/profile/loading';

export const Route = createFileRoute('/_private/awards/$id')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getAwardQueryOptions(opts.params.id)),
  pendingComponent: Loading,
});
